const en: Record<string, string> = {
  // General
  'app.name': 'ItWorld.pet',
  'app.tagline': 'Tech-powered care for every furry friend',
  'nav.home': 'Home',
  'nav.community': 'Community',
  'nav.rescue': 'Rescue',
  'nav.products': 'Products',
  'nav.about': 'About',
  'nav.myPets': 'My Pets',
  'nav.admin': 'Admin',
  'nav.login': 'Login',
  'nav.logout': 'Logout',

  // Auth
  'auth.login': 'Login',
  'auth.register': 'Register',
  'auth.loginTitle': 'Welcome back',
  'auth.loginSubtitle': 'Sign in to your ItWorld account',
  'auth.registerTitle': 'Create account',
  'auth.registerSubtitle': 'Join ItWorld and build a digital profile for your pet',
  'auth.email': 'Email',
  'auth.password': 'Password',
  'auth.passwordPlaceholder': 'At least 6 characters',
  'auth.confirmPassword': 'Confirm password',
  'auth.confirmPasswordPlaceholder': 'Re-enter your password',
  'auth.nickname': 'Nickname',
  'auth.nicknamePlaceholder': 'What should we call you? (optional)',
  'auth.loggingIn': 'Signing in...',
  'auth.registering': 'Creating account...',
  'auth.noAccount': "Don't have an account?",
  'auth.hasAccount': 'Already have an account?',
  'auth.goRegister': 'Sign up',
  'auth.goLogin': 'Sign in',
  'auth.loginFailed': 'Login failed',
  'auth.registerFailed': 'Registration failed',

  // Validation
  'validation.emailRequired': 'Please enter your email address',
  'validation.emailInvalid': 'Invalid email address',
  'validation.passwordRequired': 'Please enter your password',
  'validation.passwordMin': 'Password must be at least 6 characters',
  'validation.passwordMax': 'Password must be at most 64 characters',
  'validation.confirmPasswordRequired': 'Please confirm your password',
  'validation.passwordMismatch': 'Passwords do not match',
  'validation.nicknameMax': 'Nickname must be at most 20 characters',

  // Pets
  'pets.myPets': 'My Pets',
  'pets.manage': 'Manage your registered pets',
  'pets.add': 'Add Pet',
  'pets.edit': 'Edit',
  'pets.delete': 'Delete',
  'pets.confirmDelete': 'Delete {{name}}?',
  'pets.deleteFailed': 'Failed to delete',
  'pets.loading': 'Loading pet profiles...',
  'pets.empty': 'No pets yet. Add your first pet!',

  // Community
  'community.title': 'Community',
  'community.publish': 'Post',
  'community.loading': 'Loading...',
  'community.empty': 'No posts yet',
  'community.like': 'Like',
  'community.comment': 'Comment',

  // Rescue
  'rescue.title': 'Rescue & Adoption',

  // Actions
  'action.save': 'Save',
  'action.cancel': 'Cancel',
  'action.confirm': 'Confirm',
  'action.back': 'Back',
  'action.loadMore': 'Load more',
  'action.retry': 'Retry',
  'action.close': 'Close',

  // Errors
  'error.generic': 'Something went wrong. Please refresh and try again.',
  'error.network': 'Network error. Please check your connection.',
  'error.notFound': 'Page not found',
  'error.unauthorized': 'Please sign in first',
  'error.forbidden': 'Access denied',
};

export default en;
